import { render, staticRenderFns } from "./VisitNotice.vue?vue&type=template&id=513fb168&scoped=true"
import script from "./VisitNotice.vue?vue&type=script&lang=js"
export * from "./VisitNotice.vue?vue&type=script&lang=js"
import style0 from "./VisitNotice.vue?vue&type=style&index=0&id=513fb168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513fb168",
  null
  
)

export default component.exports